import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/WebPageHead/WebPageHead.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/WebPageHead/WebPageHead.ts';

export const prototypeName = '1Do09dQrJkcOK0312NxefzMxxPlZGAT9ArJr9LKrIAX46MPAG8CP3zlZdGblF4goOb6gll';
export {styles};
export {script};